import { readLoginLS, removeLoginLS, saveLoginLS } from "../../functions/rememberedLogin";
import {restoreCustomerCart} from "../../hooks/restoreCart";
import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
//Redux
import { useDispatch } from "react-redux";
import { setUserLogged, setUserData, updateCart, setUserLogOut, setAlert } from "../../reducers/userConfigSlice";
import { useSelector } from "react-redux";
//Components
import { translateMessage } from "@delibrandev/utils";
import {Input} from "../../components/inputs/type1";
import { LuMail, LuEye } from "react-icons/lu";
import { RiErrorWarningFill } from "react-icons/ri";
//Api
import { logIn, googleCustomerLogin, sendCustomerVerificationCode, validateLogIn } from "../../api/login";
import { getCustomerInfo } from "../../api/profile";
import { decodeToken } from "../../api/utils";

import { loginDestination } from "./returnTarget";
import { logout } from "../../api/requests";
import { GoogleSignIn } from "./googleSignIn";
import { rememberGoogleSession, clearGoogleSession } from "../../hooks/googleSession";
import { logoutRevision } from "../../hooks/shopSession";
import { apiRest } from "../../api/constants";

export const FormLogin = ({ callback, checkoutAccess = false, onVerificationRequired = () => {} }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const componentActive = useSelector((state) => state.aplicationConfig.userConfig.componentActive);
  const cart = useSelector((state) => state.aplicationConfig.userConfig.cart);

  const submitting = useRef(false);
  const [pending,setPending]=useState(false);
  const [loginFailed, setLoginFailed] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [require2FA, setRequire2FA] = useState(false);
  const [verificationPhone, setVerificationPhone] = useState("");
  const [codeSent, setCodeSent] = useState(false);

  const [googleReset, setGoogleReset] = useState(0);
  const mounted = useRef(true);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  const handleGoogleLogin = async credential => {
    if (submitting.current || !credential) return;
    const revision = logoutRevision();
    submitting.current = true; setPending(true); setLoginError("");
    try {
      const result = await googleCustomerLogin(credential);
      if (!mounted.current || revision !== logoutRevision()) { await logout(); return; }
      if (result?.error !== false) throw new Error(result?.message || "No se pudo iniciar sesión con Google.");
      const profile = await getCustomerInfo({});
      if (!mounted.current || revision !== logoutRevision()) { await logout(); return; }
      if (profile?.error !== false) throw new Error("No se pudo recuperar tu cuenta. Inténtalo de nuevo.");
      const restored = await restoreCustomerCart(profile.data.customerId, cart);
      if (!mounted.current || revision !== logoutRevision()) { await logout(); return; }
      removeLoginLS(apiRest); rememberGoogleSession();
      dispatch(setUserData(profile.data)); dispatch(updateCart(restored)); dispatch(setUserLogged(true));
      navigate(loginDestination(location.search, componentActive), { replace: true });
    } catch (error) { if (mounted.current) { setLoginError(error.message); setGoogleReset(value => value + 1); } }
    finally { submitting.current = false; if (mounted.current) setPending(false); }
  };

  const request2FA = async () => {
    if (submitting.current) return;
    submitting.current = true; setPending(true); setLoginError("");
    try {
      const response = await sendCustomerVerificationCode();
      if (response?.error !== false) throw new Error("send failed");
      setCodeSent(true); setLoginFailed(false);
    } catch {
      setLoginError("No se ha podido enviar el SMS. Inténtalo de nuevo.");
    } finally { submitting.current = false; setPending(false); }
  };

  const handleLogin = async () => {
    if(submitting.current)return;
    submitting.current=true;setPending(true);
    setLoginError("");
    try {
    const email = document.getElementById("emailInput").value;
    const password = document.getElementById("passwordInput").value;
    const remember = document.getElementById("passwordSave").checked;
    const data = {
      email: email,
      password: password,
    };
    const response = await logIn(data);
    if (response && !response.error) {

      //dispatch(setAlert(translateMessage(response?.message || "Bad request")));


      clearGoogleSession();
      if (remember) saveLoginLS(data, apiRest);
      else removeLoginLS(apiRest);

      // Obtener información del cliente
      const responseCustomerInfo = await getCustomerInfo({});
      console.log("getCustomerInfo: ", responseCustomerInfo);
      if (responseCustomerInfo && !responseCustomerInfo.error) {
        try {
          const restored=await restoreCustomerCart(responseCustomerInfo.data.customerId,cart);
          dispatch(setUserData(responseCustomerInfo.data));
          dispatch(setUserLogged(true));
          dispatch(updateCart(restored));
        } catch(error) {
          dispatch(setAlert({called:true,type:"error",title:"Carrito pendiente de recuperar",message:error.message}));
          return;
        }
        navigate(loginDestination(location.search, componentActive), { replace: true });
      } else if (responseCustomerInfo.message === "The customer must be verified.") {
        const identity = decodeToken(response.data?.data);
        const digits = String(identity?.phone || "").replace(/\D/g, "");
        setVerificationPhone(digits.length >= 6 ? `••• ••• ${digits.slice(-3)}` : "");
        setLoginFailed(false);
        setRequire2FA(true);
        onVerificationRequired();
      } else {
        dispatch(setUserLogOut());
        navigate(loginDestination(location.search, componentActive), { replace: true });
      }
    } else {
      dispatch(setAlert({ called: true, title: "Error", message: "datos de acceso incorrectos", type: "error" }));
      setLoginError("El usuario o la contraseña no son correctos. Inténtalo de nuevo.");
      setLoginFailed(true);
    }
    } catch(error) { setLoginError("No se pudo iniciar sesión. Inténtalo de nuevo."); dispatch(setAlert({called:true,type:"error",title:"No se pudo iniciar sesión",message:error.message})); } finally {submitting.current=false;setPending(false);}
    //dispatch(setUserLogged(true));
    //navigate("/profile");
  };

  const handle2FA = async () => {
    setLoginError("");
    const code = document.getElementById("2faInput").value;
    const response = await validateLogIn({
      code: code,
    });
    //const responseDecoded = decodeToken(response.data);
    if (response && !response.error) {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      const responseCustomerInfo = await getCustomerInfo({});
      console.log("getCustomerInfo: ", responseCustomerInfo);
      if (responseCustomerInfo && !responseCustomerInfo.error) {
        const restored=await restoreCustomerCart(responseCustomerInfo.data.customerId,cart);
        dispatch(setUserData(responseCustomerInfo.data));
        dispatch(updateCart(restored));
        dispatch(setUserLogged(true));
        navigate(loginDestination(location.search, componentActive), { replace: true });
      } else {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
        setLoginFailed(false);
      }
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      setLoginFailed(true);
    }
  };

  const LoginComponent = () => {
    const savedLogin = readLoginLS(apiRest);
    return (
      <>
        <GoogleSignIn disabled={pending} onCredential={handleGoogleLogin} reset={googleReset} />
        <label htmlFor="emailInput" className="labelLogin">Email</label>
        <Input
          id={"emailInput"}
          type={"email"}
          autoComplete="username"
          placeholder={checkoutAccess ? "tu@email.com" : ""}
          disabled={pending}
          onKeyPress={() => null}
          iconPositionRight={!checkoutAccess}
          icon={<LuMail />}
          classname={loginFailed ? "errorValueInput w-100" : "w-100"}
          defaultValue={savedLogin?.email ? savedLogin?.email : ""}
        />
        <label htmlFor="passwordInput" className="labelLogin">Contraseña</label>
        <Input
          id={"passwordInput"}
          type={"password"}
          autoComplete="current-password"
          placeholder=""
          disabled={pending}
          onKeyPress={() => null}
          icon={<LuEye />}
          iconType={"tooglePasswordVisibility"}
          classname={loginFailed ? "errorValueInput w-100" : "w-100"}
          defaultValue={savedLogin?.password ? savedLogin?.password : ""}
        />
        {loginError ? (
          <div className="errorValue errorMessage" role="alert">
            <RiErrorWarningFill /> {loginError}
          </div>
        ) : (
          ""
        )}

        <div className="flex infoLoginPass mt-1">
          <div className="w-50">
            <label htmlFor="passwordSave">
              <input id="passwordSave" aria-label="Recordar contraseña" disabled={pending} type="checkbox" className="custom-checkbox" style={{ width: "20px", height: "20px" }} />{" "}
              <span>Recordar contraseña</span>
            </label>
          </div>
          {!checkoutAccess && <div className="w-50">
            <button type="button" className="forgetPass" disabled={pending} onClick={callback}>
              He olvidado mi contraseña
            </button>
          </div>}
        </div>

        <button className="button-1" disabled={pending} aria-busy={pending} type="submit">
          {pending?"Recuperando carrito…":"Iniciar sesión"}
        </button>
        {checkoutAccess && <button type="button" className="forgetPass eats-checkout-forgot" disabled={pending} onClick={callback}>He olvidado mi contraseña</button>}
      </>
    );
  };

  const Login2FA = () => {
    return (
      <>
        <p role="status">{codeSent ? "Hemos enviado un código por SMS" : "Puedes solicitar un código por SMS"}{verificationPhone ? <> al teléfono <strong>{verificationPhone}</strong>.</> : " al teléfono asociado a tu cuenta."}{!codeSent && " Pulsa «Enviar código por SMS» para recibir uno nuevo."}</p>
        <label htmlFor="2faInput" className="labelLogin">Código de verificación</label>
        <Input
          key="verification-code"
          id={"2faInput"}
          autoComplete="one-time-code"
          inputMode="numeric"
          type={"text"}
          placeholder=""
          disabled={pending}
          onKeyPress={() => null}
          icon={null}
          classname={loginFailed ? "errorValueInput" : ""}
        />
        {loginFailed ? (
          <div className="errorValue errorMessage" role="alert">
            <RiErrorWarningFill /> {"El código es incorrecto o ha caducado"}
          </div>
        ) : (
          ""
        )}

        {loginError && <p role="alert">{loginError}</p>}
        <div className="flex infoLoginPass mt-1">
          <button
            type="button"
            className="forgetPass w-100"
            disabled={pending}
            aria-busy={pending}
            onClick={request2FA}
            style={{ background: "none", border: "none", padding: 0, margin: 0, textAlign: "left", cursor: "pointer" }}
          >
            {pending ? "Procesando…" : codeSent ? "Volver a pedir el código por SMS" : "Enviar código por SMS"}
          </button>
        </div>

        <button className="button-1" disabled={pending} aria-busy={pending} type="submit">
          Acceder
        </button>
      </>
    );
  };

  return <form onSubmit={event => { event.preventDefault(); if (require2FA) { if (submitting.current) return; submitting.current = true; setPending(true); handle2FA().catch(() => setLoginError("No se ha podido verificar el código. Inténtalo de nuevo.")).finally(() => { submitting.current = false; setPending(false); }); } else handleLogin(); }}>{!require2FA ? LoginComponent() : Login2FA()}</form>;
};
